<template>
	<el-container v-bind:style="{ height: screenHeight - 60 + 'px' }">
		<el-header>
			<div :class="{ expiringTips: true, show: expiringDateTip }">{{ expiringDateTip }}</div>
			<h2>
				<img v-bind:src="logoImage" alt />
				<span v-text="pageTitle"></span>
			</h2>
			<el-dropdown trigger="click" @command="dropdownClick">
				<span class="el-dropdown-link">
					欢迎，{{ nickname }}【{{ roleName }}】
					<i class="el-icon-arrow-down el-icon--right"></i>
				</span>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item icon="el-icon-lock" command="selectFactory" v-show="factoryList.length && listValue">切换工厂</el-dropdown-item>
					<el-dropdown-item icon="el-icon-lock" command="showSystemInfo">系统信息</el-dropdown-item>
					<el-dropdown-item icon="el-icon-lock" command="changePassword">修改密码</el-dropdown-item>
					<el-dropdown-item icon="el-icon-switch-button" command="logout">退出</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</el-header>

		<el-container>
			<el-aside width="auto" v-bind:style="{ height: screenHeight - 60 + 'px' }">
				<el-scrollbar style="height: 100%">
					<Menu v-on:changeCollapse="changeCollapse" />
				</el-scrollbar>
			</el-aside>

			<transition class="menuMain" name="fade" mode="out-in" appear>
				<el-main v-bind:style="{ height: screenHeight - 60 + 'px' }">
					<el-scrollbar style="height: 100%">
						<keep-alive>
							<router-view v-if="$route.meta.keepAlive" class="page-body" />
						</keep-alive>

						<router-view v-if="!$route.meta.keepAlive" class="page-body" />
					</el-scrollbar>
				</el-main>
			</transition>
		</el-container>

		<el-dialog title="切换工厂" :visible.sync="dialogChangeFactoryVisible">
			<div>
				<div v-for="(item, index) in factoryList" :key="index" :style="{ marginBottom: '10px' }">
					<el-radio v-model="selectedFactoryName" :label="item.databaseName" border :style="{ width: '100%' }">{{ item.name }}</el-radio>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogChangeFactoryVisible = false">取消</el-button>
				<el-button type="primary" @click="changeFactory">确定</el-button>
			</div>
		</el-dialog>
	</el-container>
</template>

<script>
	import Menu from '../components/Menu.vue'
	import { mapActions, mapGetters, mapState } from 'vuex'
	import { FACTORIES } from '@/store/mutation-types'
	import moment from 'moment'
	import { axios } from '@/network/util/request'
	export default {
		name: 'home',
		data() {
			return {
				msg: window.localStorage.getItem('name'),
				logo: require('../assets/images/lusterinc-logo.png'),
				screenHeight: 0,
				expiringDateTip: '',
				dialogChangeFactoryVisible: false,
				selectedFactoryName: '',
			}
		},
		components: {
			Menu,
		},
		computed: {
			...mapState({ logoImage: state => state.app.factoryLogoUrl, expiringDate: state => state.app.expiringDate, roles: state => state.user.allRoles }),
			...mapGetters(['nickname', 'roleCodes', 'avatar', 'userInfo', 'isPublic']),
			/**
			 * 集团名称
			 */
			company() {
				return localStorage.getItem('company')
			},
			listValue() {
				if (process.env.VUE_APP_VERSION == 'public') {
					return true
				} else {
					return false
				}
			},
			/**
			 * 工厂名称，数据库名称。
			 */
			database() {
				return localStorage.getItem('database')
			},
			/**
			 * 系统标题。
			 */
			pageTitle() {
				if (this.isPublic) {
					return 'GMQM公有云'
				}

				return 'GMQM私有云'
			},
			factoryList() {
				try {
					var array = this.$ls.get(FACTORIES)

					if (!array) {
						array = []
					}

					return array
				} catch (error) {
					return []
				}
			},
			/**
			 * 角色名称。
			 */
			roleName() {
				var roleName = []
				if (this.roles && this.roleCodes.length > 0) {
					var codes = this.roleCodes.split(',')
					codes.forEach((code, index) => {
						var role = this.roles.find(t => t.roleCode == code)
						if (role) {
							roleName.push(role.roleName)
						}
					})
				}

				var result = roleName.join(',')

				return result
			},
		},
		watch: {
			/**
			 * 检查到期日。
			 */
			expiringDate(date) {
				if (date) {
					var diffDays = moment(date).diff(moment(), 'days')
					//diffDays = 10
					console.log('diffDays', diffDays)
					if (diffDays <= 30) {
						this.expiringDateTip = '系统即将到期，请联系凌云光管理员续费！到期日期：' + moment(date).format('YYYY年MM月DD日')
					}
				}
			},
			/**
			 * 监控路由。
			 */
			$route(to, from) {
				console.log('路由监控', to)
				this.queryCompare()
			},
		},
		methods: {
			doPouddSgn(str) {
				if (process.env.VUE_APP_VERSION == 'public') {
					if (str == '#') {
						return 'gmqm'
					} else if (str.split('').pop() == '#' && str.length > 1) {
						return str.slice(0, str.length - 1)
					}
					return str
				} else {
					return str
				}
			},
			...mapActions(['Logout']),
			queryCompare() {
				//http://localhost:9096/#/Index?factory=SmartFABDB&company=chengxin
				//公有云从url读取参数。
				var s = window.location.href.split('/')[3]
				var query_company = ''
				if (process.env.VUE_APP_VERSION == 'public') {
					query_company = this.doPouddSgn(s)
				} else {
					query_company = this.$route.query.company
				}

				var query_factory = this.$route.query.factory
				console.log('url company', query_company)
				console.log('url factory', query_factory)
				console.log('this company', this.company)
				console.log('this factory', this.database)

				if (query_factory) {
					if (this.database != query_factory) {
						console.log('修改数据库名称', query_factory)
						//如果工厂有变化，修改本地数据库配置。
						localStorage.setItem('database', query_factory)
					}
				}

				if (query_company) {
					if (this.company != query_company) {
						//如果集团有变化，退出重新登录。
						this.Logout()
							.then(() => {
								window.location.href = `/${query_company}/`
							})
							.catch(err => {
								this.$message.error({
									title: '错误',
									description: err.message,
								})
							})
					}
				}
			},
			changePassword() {
				this.$router.push({ name: 'changePassword' })
			},
			dropdownClick(command) {
				console.log(command)
				this[command]()
			},
			/**
			 * 选择工厂。
			 */
			selectFactory() {
				this.dialogChangeFactoryVisible = true
			},
			/**
			 * 切换工厂。
			 */
			changeFactory() {
				this.$router.push({
					query: {
						factory: this.selectedFactoryName,
					},
				})

				this.dialogChangeFactoryVisible = false
				//强制刷新。
				window.location.reload()
			},
			/**
			 * 查看系统信息。
			 */
			showSystemInfo() {
				this.$router.push({ name: 'systemInfo' })
			},
			/**
			 *
			 */
			changeCollapse(isCollapse) {
				console.log('changeCollapse', isCollapse)
				var elMain = document.getElementsByClassName('el-main')[0]
				if (elMain) {
					if (isCollapse) {
						elMain.classList.remove('collapse_open')
						elMain.classList.add('collapse_close')
					} else {
						elMain.classList.remove('collapse_close')
						elMain.classList.add('collapse_open')
					}
				}
			},
			logout() {
				const that = this
				this.$confirm('真的要注销登录吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				})
					.then(() => {
						that
							.Logout({})
							.then(() => {
								//window.location.href = '/'
								this.$router.push({ name: 'SignIn' })
							})
							.catch(err => {
								that.$message.error({
									title: '错误',
									description: err.message,
								})
							})
					})
					.catch(err => {
						that.$message.error(err.message)
					})
			},
		},
		mounted() {
			this.screenHeight = document.body.scrollTop
			window.onresize = () => {
				return (() => {
					this.screenHeight = document.body.clientHeight
				})()
			}

			console.log('screenHeight', this.screenHeight)
		},
		created() {
			this.queryCompare()
			this.$store.dispatch('getGlobalConfig', { factory: this.database })
			this.$store.dispatch('getExpiringDate', this.company)
			this.$store.dispatch('getAllRoles')
		},
	}
</script>
